import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AsyncPaginate } from "react-select-async-paginate";

/**
 * @deprecated
 */
function EventCategoryFilter({
  category,
  fetchCategories,
  onChange,
  styles = {},
}) {
  return (
    <AsyncPaginate
      additional={{
        page: 0,
      }}
      isSearchable={false}
      className="react-select info react-select-btn"
      classNamePrefix="react-select"
      placeholder="Class Type"
      components={{
        DropdownIndicator: ({ selectProps: { menuIsOpen } }) => {
          if (menuIsOpen) {
            return <FontAwesomeIcon icon={faAngleUp} />;
          }
          return <FontAwesomeIcon icon={faAngleDown} />;
        },
      }}
      loadOptions={async () => {
        const { data } = await fetchCategories({
          statusList: ["ACTIVE"],
        }).catch((err) => console.error(err));
        const options = data.content.map((category) => ({
          value: category.id,
          label: category.name,
        }));
        options.unshift({ value: null, label: "All" });
        return {
          hasMore: false,
          options,
        };
      }}
      value={category}
      onChange={onChange}
      styles={{
        control: (provided) => ({
          ...provided,
          minWidth: 150,
          borderRadius: "30px !important",
        }),
        ...styles,
      }}
    />
  );
}

export default EventCategoryFilter;
